import _ from 'lodash';
import PropTypes from 'prop-types';
import { Image } from '../shared';

import useResponsive from '../../../utils/responsive';


const InvestorsSection = (props) => {
    const {
        title,
        paragraph,
        imgSrc,
        imgAlt,
        subHeading,
        paragraphContent,
    } = props;
    
    const { isMobile, isTablet } = useResponsive();
    const isSmallScreen = isMobile || isTablet;

    const renderImageSection = () => {
        return (
            <div>
                {isSmallScreen && <h3 className='investors-section-sub-heading'>{subHeading}</h3>}
                <Image src={imgSrc} alt={imgAlt} isOldImage className='general-image' />
            </div>
        );
    };

    const renderTextSection = () => {
        return (
            <div>
                {!isSmallScreen && <h3 className='investors-section-sub-heading'>{subHeading}</h3>}
                {renderParagraphs()}
            </div>
        );
    };

    const renderParagraphs = () => {
        if (!paragraphContent) {
            return null;
        }

        return paragraphContent.map((content, index) => {
            const paragraphTitle = _.get(content, 'paragraph_title');
            const paragraphText = _.get(content, 'paragraph_text');
            return (
                <div key={index}>
                    <div>
                        <h5>{paragraphTitle}</h5>
                        <p className='investors-section-paragraph-text'>{paragraphText}</p>
                    </div>
                </div>
            );
        });
    };

    return (

        <div className='container-root container-root-maxWidthLg' id="investors">

            <div className='investors-section-intro-section'>
                <p className='dummy-header-two' style={{ marginBottom: 24 }}>{title}</p>
                <p className='investors-section-section-paragraph'>{paragraph}</p>
            </div>

            <div className='main-grid-container main-grid-spacing-xs-3 investors-section-grid-container'>

                <div className='main-grid-item main-grid-lg-6'>
                    {renderImageSection()}
                </div>

                <div className='main-grid-item main-grid-lg-5'>
                    {renderTextSection()}
                </div>

            </div>

        </div>

    );
};

export default InvestorsSection;

InvestorsSection.propTypes = {
    isMobile: PropTypes.bool,
    isTablet: PropTypes.bool,
    title: PropTypes.string,
    paragraph: PropTypes.string,
    subHeading: PropTypes.string,
    imgSrc: PropTypes.string,
    imgAlt: PropTypes.string,
    paragraphContent: PropTypes.array,
};
